exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-list[data-v-2cabfe80]{height:300px;min-height:100px;overflow:auto;padding:0;margin:0}.tags-list li[data-v-2cabfe80]{display:block;font-weight:500;border-top:1px #fff;border-bottom:1px #fff;text-decoration:none}.tags-list li[data-v-2cabfe80]:hover{color:#fff;background-color:#286efa}.header[data-v-2cabfe80]{font-size:26px}.footer[data-v-2cabfe80]{border-top:1px solid #bbb}.tags-search[data-v-2cabfe80] .q-if-control{cursor:default;pointer-events:none}.tags-search[data-v-2cabfe80] .q-if-control:hover{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cabfe80","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/TagsPicker/TagsPicker.vue
// module id = L4QH
// module chunks = 0